import auth from "@/api/auth";
import contact from "@/api/contact";

const state = {
  showLogin: false,
  token: "",
  form: "",
  register: "",
  loggingIn: "",
  forgotPassword: "",
  user: {},
  firstName: "",
  page: "login",
};

const getters = {
  isLoggedIn(state) {
    return state.token.length > 0;
  },
};

const mutations = {
  setPageRoute(state, page) {
    state.page = page;
  },
  updateName(state, value) {
    state.user.name = value;
  },
  updateEmail(state, value) {
    state.user.email = value;
  },
  updateFilter(state, value) {
    state.user.filter = value;
  },
  setUser(state, user) {
    state.user.name = user.name;
    state.user.email = user.email;
    state.user.filter = user.filter;
  },
  setToken(state, token) {
    state.token = token;
  },
  registering(state, user) {
    state.register = user;
  },
  openLogin(state) {
    state.showLogin = true;
  },
  closeLogin(state) {
    state.showLogin = false;
  },
  sendForm(state, form) {
    state.form = form;
  },
  loggingIn(state, user) {
    state.loggingIn = user;
  },
  newPassword(state, user) {
    state.forgotPassword = user;
  },
  getUser(state, user) {
    state.user = user;
    state.user.filter = "En";
    // TODO: Remove this once API Updated
  },
  getFirstName(state) {
    let name = state.user.name.split(" ");
    state.firstName = name[0];
  },
};

const actions = {
  getUserDB({ commit }) {
    auth.userInfo().then((res) => {
      commit("getUser", res.data);
      commit("getFirstName");
    });
  },
  setUser({ commit }, user) {
    auth.setUserinfo(user);
  },
  setPassword({ commit }, password) {
    auth.setPasswordinfo(password);
  },
  twoStep({ commit }, user) {
    auth.loginUser(user).then((res) => {
      commit("loggingIn", res.data);
    });
  },
  login({ commit }, user) {
    auth.loginUser(user).then((res) => {
      commit("setToken", res.data);
      commit("closeLogin");
      localStorage.setItem("token", res.data);
    });
  },
  logout({ commit }) {
    commit("setToken", "");
    localStorage.removeItem("token");
  },
  register({ commit }, user) {
    auth.register(user).then((res) => {
      commit("registering", res.data);
    });
  },
  forgotPassword({ commit }, user) {
    auth.forgotPassword(user).then((res) => {
      commit("newPassword", res.data);
    });
  },
  contactHome({ commit }, form) {
    contact.contactHome(form).then((res) => {
      commit("sendForm", res.data);
    });
  },
  contactDashboard({ commit }, form) {
    contact.contactDashboard(form).then((res) => {
      commit("sendForm", res.data);
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
